// extracted by mini-css-extract-plugin
module.exports = {"antFadeIn":"antFadeIn"};